import { LookupUrl } from 'autogen/swagger/all';
import searchProducts from '../searchProducts';

type SearchRequest = {
    term: string;
};

function isValidHTTPUrl(string: string): boolean {
    try {
        const newUrl = new URL(string);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch (err) {
        return false;
    }
}

async function URLSearch(url: string) {
    return LookupUrl({ url }).then((res) => {
        const { productId } = res;

        return productId;
    });
}

export default async function provideSearchData(searchRequest: SearchRequest, searchResponse: any) {
    const { term } = searchRequest;
    const isURL = isValidHTTPUrl(term);
    const searchString = isURL ? (await URLSearch(term)).toString() : term;

    searchProducts(searchString).then((yourSearchResponse) => {
        searchResponse((response) => {
            const {
                products: { items }
            } = yourSearchResponse;

            return response
                .products((p) => {
                    const results = items.map((prod) =>
                        p()
                            .name(prod.name)
                            .imageUrl(prod.image.url)
                            .sku(prod.id)
                            .price((price) =>
                                price.current(prod.price.priceText).original(prod.price.priceBefore || null)
                            )
                    );
                    return results;
                })
                .currency('DKK')
                .locale('da-DK');
        });
    });
}
